<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <!-- Global Form Error Modal -->
  <FormErrorModal v-if="showErrorModal" />
</template>

<script setup lang="ts">
const { isVisible: showErrorModal } = useFormErrorModal()
</script>
